import { findParentComponent, getValueByPath } from '../utils/helper';

export default {
  data() {
    return {
      parentForm: null,
    };
  },
  props: {
    /**
     * @ignore ignore
     */
    size: String,
  },
  computed: {
    // 尺寸
    curSize() {
      return this.size || getValueByPath(this.parentForm, 'size');
    },
  },
  mounted() {
    this.parentForm = this.getParentForm();
  },
  methods: {
    getParentForm() {
      return findParentComponent(this, 'ten-form');
    },
  },
};
